module.exports = __webpack_public_path__ + "media/npc_dota_hero_storm_spirit.ebac7b83.webm";